module.exports = "/static/js/9a26e975efa947895810066b4c3d42e0.png";